// Module
var code = `<div appHeaderBar>
    <header-bar-title>Sign Up</header-bar-title>
</div>
<app-page-content [showWebFooter]="true" [usePagePadding]="true">
    <form name="RegistrationForm" id="RegistrationForm" #registrationForm="ngForm" (submit)="submit()">
        <div class="HOA-misc-guidedSteps__container" >
            <div class="HOA-container__header">
                <h1 tid="oneTimePaymentLabel"
                    id="oneTimePaymentLabel"
                    class="HOA-container__header-text">
                    Sign Up - Please Enter the Following Information
                </h1>
            </div>
            <div class="HOA-container__content">
                <div class="HOA-flex-component HOA-flex-component--direction-column">
                    <app-personal-info
                            [personalInfoData]="personalInfoData"
                            (invalidCheck)="emailAddressValid(\$event)">
                    </app-personal-info>
                </div>
            </div>
            <div class="HOA-container__content
                                HOA-container__content--borderNone
                                HOA-flex-component HOA-flex-component-sm-col-lg-row">
                <div class="HOA-flextable-component__form-vertical
                                    HOA-flextable-component__cell--alt50
                                    HOA-flextable-component__form--left" style="flex-direction: row">
                    <input type="checkbox"
                           id="optIn"
                           name="optIn"
                           tid="optIn"
                           class="Field u-cf"
                           style="margin-bottom: 26px;
                                            accent-color: #00505c;
                                            height: 15px"
                           [(ngModel)]="optIn"
                           [ngClass]="{'is-invalid': false}">
                    <label for="optIn" class="HOA-font-light">
                        Yes. I’d like to stay in touch with First Citizens Bank and agree to receive periodic email updates and offers. I understand I can unsubscribe at any time.
                    </label>
                </div>
            </div>
            <div class="HOA-container__content HOA-container__content--borderNone">
                <div class="HOA-Checking-Detail-button-container">
                    <button name="cancel"
                            id="cancel"
                            tid="cancel"
                            type="button"
                            class="Button Button--link"
                            (click)="cancel()">
                        Cancel
                    </button>
                    <button name="submit"
                            id="submit"
                            tid="submit"
                            type="submit"
                            class="Button Button--blue"
                            [disabled]="(personalInfoData.emailAddressExists && personalInfoData.isHoaHomeowner) ||
                                               registrationForm.invalid ||
                                               invalidCheckVar ||
                                               !isPhoneNumberValid() ||
                                               !personalInfoData.accountActive ||
                                               personalInfoData.emailAddressError ||
                                               personalInfoData.isValidatingEmail">
                        Next
                    </button>
                </div>
                <div class="u-pT2 HOA-flex-component HOA-font-fine-print">
                    <span class="asterisk-required">&#42;</span>&nbsp;Indicates required field
                </div>
            </div>
        </div>
    </form>
</app-page-content>`;
// Exports
module.exports = code;